import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal'
import qs from 'qs'
import Paging from '../../components/Paging'
import FormDropdown from '../../components/FormDropdown';
import {SelectPanel, MultiSelect} from "@khanacademy/react-multi-select";


class SiswaPKL extends Component {

    constructor() {
        super();
        this.state = {
            data_guruNonGps   : [],
            dataGuNonGps: [],
            dataGuGps: [],
            dataKelasAsal : [],
            dataKelasTujuan : [],
            data_tahun_ajar:[],
            data_guGps : [],
            user_id : "",
            guru_id:"",
            tahun_ajar:"",
            thn_ajar_value:"",
            kelas_id : "",
            kelas_id_tujuan:"",
            kelas_nama : "",
            pageCount    : 0,
            currentPage  : 0,
            pageCountTujuan    : 0,
            currentPageTujuan  : 0,
            isLoading    : false,
            isModalShow  : false,
            // isModalShowDelete  : false,
            checked:false,
            partPkl:[],
            partNonPkl : [],
            isAll:false,
            value: null,
            opsi:'',
            resetloc:'',
            setloc:''
        }

        // this.toggleModalDelete         = this.toggleModalDelete.bind(this)
        this.toggleModal              = this.toggleModal.bind(this)
        this.handleChange               = this.handleChange.bind(this)
        this.handleSubmitButton = this.handleSubmitButton.bind(this)
        // this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this)
        this.handleSelectedChangedNonPKL = this.handleSelectedChangedNonPKL.bind(this);
        this.handleSelectedChangedPKL = this.handleSelectedChangedPKL.bind(this);
    }

    toggleModal() {
        this.setState({ isModalShow: ! this.state.isModalShow })
    }
    
    // toggleModalDelete() {
    //     this.setState({ isModalShowDelete: ! this.state.isModalShowDelete })
    // }

    // handleSubmitDeleteButton() {

    //     const params = qs.stringify({
    //         kelas_id_tujuan:this.state.kelas_id_tujuan,
    //         guru_id:this.state.guru_id,
    //         user_id:localStorage.SISMART_USER_ID

    //     })

    //     axios({
    //         method: 'post',
    //         url: '/naik_kelas/delete?' + params
    //     })
    //         .then(response => {

    //             Alert.success("Data berhasil dihapus");
    //             this.loadDataTujuan();
    //             this.loadData();
    //             this.state.isModalShowDelete=false;


    //             return;
    //         })
    //         .catch(error => {
    //             console.log(error)
    //             this.setState({ isLoading: false })
    //             Alert.error("Gagal terhubung ke server!")
    //         })
    // }

    handleSubmitButton() {
        
        const params = qs.stringify({
            user_id:localStorage.SISMART_USER_ID,
            guru_non_gps:this.state.partNonPkl,
            guru_pgs:this.state.partPkl,
            opsi:this.state.opsi,
            resetloc:this.state.resetloc,
            setloc:this.state.setloc
        })
        
        const url ='/guru/gps';
        		
		axios
			.post(url, params)
			.then(response => {
				const result = response.data;

				if (result.success) {
                    Alert.success(result.message);
                    
                this.loadDataTujuan();
                this.loadData();
                this.state.isModalShow=false;
                this.state.partNonPkl=[];
                this.state.partPkl=[];
                this.state.resetloc='';
                this.state.setloc='';
                this.state.opsi='';
                
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
                            
                            this.state.isModalShow=false;
                            this.state.partNonPkl=[];
                            this.state.partPkl=[];
                            this.state.resetloc='';
                            this.state.setloc='';
                            this.state.opsi='';
							Alert.error(item);

							return true;
						});
					} else {
                        
                        this.state.isModalShow=false;
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
			this.setState({ showformAdd: false });
    }

    loadDataKelasAsal(){
        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key : item.kelas_id,
                    value : item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelasAsal: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    loadDataKelasTujuan(){
        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key : item.kelas_id,
                    value : item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelasTujuan: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    handleChange(event) {
        
        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })
      
    }
    
    loadData() {    

        this.setState({ isLoading: true })

        const params = qs.stringify({
            page: this.state.currentPage + 1
        })
        
        axios({
            method: 'post',
            url: '/guru_non_gps?' + params
        })
        .then((response) => {

            const result = response.data

            if (result.success === true) {                
                
                this.setState({
                    data_guruNonGps : result.data.data,
                    pageCount  : result.data.last_page,
                    isLoading  : false 
                })
                // this.selected=[],
                this.loadDataTujuan()
            }
            else {
           
                Alert.error(result.message)
                this.setState({ isLoading: false })
            }      
        })
        .catch((error) => {
            console.log(error)
            this.selected=[]
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
    }

    handleSelectedChangedNonPKL(partNonPkl) {
        this.setState({partNonPkl});

    }

    handleSelectedChangedPKL(partPkl) {
        this.setState({partPkl});

    }

    loadDataTujuan() {

        this.setState({ isLoading: true })

        const params = qs.stringify({
            page: this.state.currentPageTujuan + 1
        })
        
        axios({
            method: 'post',
            url: '/guru_gps?' + params
        })
        .then((response) => {

            const result = response.data

            if (result.success === true) {
                this.setState({
                    data_guGps : result.data.data,
                    pageCountTujuan : result.data.last_page,
                    isLoading  : false 
                })
                // this.selected=[]
            }
            else {
           
                Alert.error(result.message)
                this.setState({ isLoading: false })
                this.selected=[]
            }      
        })
        .catch((error) => {
            console.log(error)
            this.selected=[]
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
    }
    
    componentDidMount() {
        this.loadData();
        this.loadDataKelasAsal();
        this.loadDataKelasTujuan();
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.kelas_id !== this.state.kelas_id ||
            prevState.kelas_id_tujuan !== this.state.kelas_id_tujuan  ) {
            this.loadData(),
            this.loadDataTujuan(),
            this.setState({
                isAll: false
            });
        }
    }

    render () {
        const dataGuNonGps = this.state.data_guruNonGps.map(item => ({
            value: item.guru_id,
            label: item.user_nama+' - '+item.guru_nip
        }));

        const dataGuGps = this.state.data_guGps.map(item => ({
            value: item.guru_id,
            label: item.user_nama+" - "+item.guru_nip+" - "+(item.def_loc == 1 ? 'lokasi acak':'lokasi tetap')
        }));

        const {partNonPkl} = this.state;
        const {partPkl} = this.state;
        return (         
            <div className="col-sm-12">

                <CustomModal
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    handleSubmit={this.handleSubmitButton}
                    modalHeaderText="Data Guru"
                    modalBodyText={"Anda yakin mengubah data ini ... ?"}
                    modalSubmitText="Ya" />
                
                
                {/* <CustomModal
                    isShow={this.state.isModalShowDelete}
                    toggleModal={this.toggleModalDelete}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Hapus Data"
                    modalBodyText="Anda yakin ingin menghapus data ini?"
                    modalSubmitText="Ya" /> */}

                <div className="card">
                    <div className="card-header">
                        Data Guru Penentuan Absensi GPS
                    </div>
                    <div className="card-block">
                        <b>Note :</b>
                        <p><b>Absensi GPS:</b> Tombol absensi GPS pada smartphone guru diaktifkan. Guru menentukan lokasi awal lalu absensi foto selfi dengan radius 100m dari lokasi awal tersebut</p>
                        <p><b>Lokasi Acak:</b> Ketentuan lokkasi awal dihilangkan, guru dapat melakukan absensi GPS dengan lokasi yang berbeda-beda (acak)</p>
                        <p><b>Hapus Lokasi:</b> Koordinat lokasi awal dihapus, guru dapat menentukan lokasi awal baru untuk dapat melakukan absensi GPS</p>
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                        <div className="col-md-6 ">
                                {
                                    this.state.isLoading ? "Memuat Data..." : (
                                        this.state.data_guruNonGps.length == 0 ? "Data Kosong..." : (
                                            <div className='card'>
                                                <div className="card-header">
                                                    Data Guru - Non Absensi GPS
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-primary btn-sm float-right"
                                                        disabled={this.state.isButtonLoading && "disabled"}
                                                        // onClick={this.handleSubmit}
                                                        onClick={() => {
                                                            this.setState({opsi:'0'})
                                                            this.toggleModal();
                                                        }}
                                                    >
                                                        {this.state.isButtonLoading ? "Loading" : "Simpan"}
                                                    </button>
                                                </div>

                                                <SelectPanel
                                                    options={dataGuNonGps}
                                                    onSelectedChanged={this.handleSelectedChangedNonPKL}
                                                    hasSelectAll
                                                    focusIndex={1}
                                                    selected={partNonPkl}
                                                    disableSearch={false}
                                                />
                                            </div>
                                        )
                                    )
                                }
                            </div><div className="col-md-6">
                                {
                                    this.state.isLoading ? "Memuat Data..." : (
                                        this.state.data_guGps.length === 0 ? "Data Kosong..." : (
                                            <div className='card'>
                                                <div className="card-header">
                                                    Data Guru - Absensi GPS
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-primary btn-sm float-right"
                                                        style={{marginLeft:13}}
                                                        disabled={this.state.isButtonLoading && "disabled"}
                                                        // onClick={this.handleSubmit}
                                                        onClick={() => {
                                                            this.setState({opsi:'1'})
                                                            this.toggleModal();
                                                        }}
                                                    >
                                                        {this.state.isButtonLoading ? "Loading" : "Simpan"}
                                                    </button>
                                                    
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-primary btn-sm float-right"
                                                        disabled={this.state.isButtonLoading && "disabled"}
                                                        style={{marginLeft:13}}
                                                        onClick={() => {
                                                            this.setState({opsi:'1',resetloc:'1'})
                                                            this.toggleModal();
                                                        }}
                                                    >
                                                        {this.state.isButtonLoading ? "Loading" : "Hapus Lokasi"}
                                                    </button>
                                                    
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-primary btn-sm float-right"
                                                        disabled={this.state.isButtonLoading && "disabled"}
                                                        // onClick={this.handleSubmit}
                                                        onClick={() => {
                                                            this.setState({opsi:'1',resetloc:'1',setloc:'1'})
                                                            this.toggleModal();
                                                        }}
                                                    >
                                                        {this.state.isButtonLoading ? "Loading" : "Lokasi Acak"}
                                                    </button>
                                                </div>
                                                <SelectPanel
                                                    options={dataGuGps}
                                                    onSelectedChanged={this.handleSelectedChangedPKL}
                                                    hasSelectAll
                                                    focusIndex={1}
                                                    selected={partPkl}
                                                    disableSearch={false}
                                                />
                                            </div>
                                        )
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>                   
        )
    }
}

export default SiswaPKL;



// WEBPACK FOOTER //
// ./src/views/Users/Gurugps.js